import React, { useState,useEffect } from "react";
import axios from "axios";
import { API_URL,RESPONSE_SUCCESS,VALID_PHONE_PATTERN } from './../GlobalConstents.js';
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import * as trans from '../FrontMessages';
import { ROUTE_SIGN_UP,ROUTE_FORGOT_PASSWORD } from '../RouteConstents';
import ShowError from "./ShowError";

const UserLogin = () => {

    const navigate = useNavigate();

    const { register, handleSubmit, formState: { errors } } = useForm();
    const [phone, setPhone] = useState('');
    const [password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    useEffect(
        () => {
        document.body.classList.add('login-page');
    });        
    
    const onSubmit = async (data) => {
        setIsLoading(true);
        let objValue =  {
            "method_name":"userLogin",
            "phone":data.phone,
            "password": data.password
        }
        
        await axios.post(API_URL,objValue).then(function (response) {
            if (response.status === RESPONSE_SUCCESS) {
                if(response.data.status === "success") {
                    toast.success(response.data.message); 
                    localStorage.setItem("userInfo", JSON.stringify(response.data.userInfo));
                    navigate('/dashboard');
                } else {
                   toast.error(response.data.message);
                   setIsLoading(false);  
                }
            }
        
        }).catch(function (error) {
            toast.error(error.message);
            setIsLoading(false); 
        });
        
    }

    return (
        <div>
            
            <div className="login-box">
                <div className="logo">
                    <img src="./assets/images/logo.png" alt="SBS" width="100" />
                </div>
                <div className="card ">
                    <div className="body">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <br/>
                            <div className="input-group">
                                <div className="form-line">
                                    <input 
                                        type="tel" 
                                        className="form-control" 
                                        name="phone"
                                        maxLength="10" 
                                        placeholder="Phone" 
                                        onChange={(e) => setPhone(e.target.value)}
                                        {...register("phone",{ 
                                            required: trans.PLEASE_ENTER_PHONE,
                                            pattern: {
                                                value: VALID_PHONE_PATTERN,
                                                message: trans.PLEASE_ENTER_VALID_PHONE
                                            },
                                        } ) }
                                    />
                                </div>
                                <ShowError errorsModal={errors.phone} /> 
                            </div>
                            <div className="input-group">
                                <div className="form-line">
                                    <input 
                                        type="password" 
                                        className="form-control" 
                                        name="password"
                                        placeholder="Password" 
                                        onChange={(e) => setPassword(e.target.value)}
                                        {...register("password",{ 
                                            required: trans.PLEASE_ENTER_PASSWORD,
                                        })}
                                    />
                                </div>
                                <ShowError errorsModal={errors.password} />
                            </div>
                            <div className="row">
                                <div className="col-xs-12 text-center">
                                    <button 
                                        disabled={isLoading}  
                                        style={{ cursor: isLoading ? 'not-allowed' : 'pointer' }} 
                                        className="btn bg-pink waves-effect" type="submit"
                                    >Login</button>
                                </div>
                            </div>
                            <div className="text-left text-info">
                                {/*<Link to={ROUTE_FORGOT_PASSWORD}> Forgot Password </Link> */}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            {/* <div className="footer_login">
                <p><Link to={ROUTE_SIGN_UP}>Sign up</Link></p>
            </div> */}
        </div>
    );
   
}
    
export default UserLogin;